angular.module('invoice')
    .controller('InvoicePassManyController', function ($q, $scope, $rootScope, $uibModalInstance, data, Invoice, InvoiceConst, InvoiceWorkerAbsence, User, InvoiceWorkflow) {
        this.$onInit = () => {
            this.workflowConfigurationLoaded = false
            this.$invoiceStatusConfigPromise = []
            this.workerAbsenceSelection = InvoiceWorkerAbsence.selection()
            this.items = data
            this.form = data.map(item => {
                return {
                    item: item,
                    id: item.id,
                }
            })

            this.form.forEach(form => {
                this.onStatusChanged(form, form.item.status)
                InvoiceWorkflow.availableStatuses(form.item.status).then(statuses => form.statuses = statuses)
            })
            InvoiceWorkflow.load().then(configuration => {
                this.commentRequiredBeforeStatuses = configuration.commentRequiredBeforeStatuses || []
                this.workflowConfigurationLoaded = true
            })
        }
        this.getCommonStatuses = () => {
            if (this.form.length === 0) return [];
            let result = this.form[0].statuses || [];
            for (let i = 1; i < this.form.length; i++) {
                result = result.filter(s => this.form[i].statuses.includes(s));
            }
            return result;
        }
        this.onStatusCommonChanged = (newStatus) => {
            this.status = newStatus;
            delete this.user
            this.usersCommon = []
            this.workerAbsenceSelection.clear()
            $q.all(this.form.map(form => this.onStatusChanged(form, newStatus))).then(() => {
                this.usersCommon = this.form[0].users || []
                this.form.forEach(form => {
                    this.usersCommon = this.usersCommon.filter(s => form.users?.includes(s));
                })
            })
        }
        this.onUserCommonChanged = (user) => {
            this.user = user
            this.form.forEach(form => form.worker = user)
            this.workerAbsenceSelection.load(this.form.map(form => form.worker))
        }
        this.onCommentCommonChanged = () => {
            this.form.forEach(form => form.comment = this.comment)
        }
        this.onCommentFormChanged = () => {
            delete this.comment
        }
        this.onUserChanged = (form, user) => {
            form.worker = user
            delete this.user
            this.workerAbsenceSelection.load(this.form.map(item => item.worker))
        }
        this.onStatusChanged = (form, newStatus) => {
            form.status = newStatus
            delete form.statusSettings
            delete form.worker
            this.workerAbsenceSelection.clear()
            if(this.isStatusTerminal(form.status)){
                form.users = []
            }
            if(form.status !== this.status){
                this.status = null
            }
            if(this.$invoiceStatusConfigPromise[form.status] == null || !this.$invoiceStatusConfigPromise[form.status].$$state.pending) {
                this.$invoiceStatusConfigPromise[form.status] = Invoice.statusSettings({status: form.status}).$promise;
            }
            return this.$invoiceStatusConfigPromise[form.status]
                .then(item => {
                    delete this.$invoiceStatusConfigPromise[form.status]
                    form.statusSettings = item.users ? item : null
                })
                .finally(() => this.refreshUsers(form))
        }
        this.refreshUsers = (form, q) => {
            if(this.$usersPromise == null || !this.$usersPromise.$$state.pending){
                this.$usersPromise = User.autocomplete({q: q}).$promise;
            }
            return this.$usersPromise.then((items) => {
                this.$usersPromise = null
                form.users = items.filter(item => form.statusSettings == null || form.statusSettings.users.map(u => u.id).indexOf(item.id) !== -1)
            })
        }
        this.isStatusTerminal = (status) => {
            if(status == null)
                return false;
            return InvoiceWorkflow.isTerminal(status)
        }
        this.isCommentRequired = (form) => {
            return form.status !== form.item.status
                && (this.commentRequiredBeforeStatuses || []).includes(form.status)
        }
        this.isCommonCommentRequired = () => {
            return (this.form || []).some(form => this.isCommentRequired(form))
        }
        this.hasMissingRequiredComment = () => {
            return (this.form || []).some(form => {
                return this.isCommentRequired(form)
                    && (!form.comment || form.comment.trim().length === 0)
            })
        }
        this.canPassToSelectedWorkers = () => this.workerAbsenceSelection.canProceed(this.form.map(form => form.worker))
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            if (!this.workflowConfigurationLoaded || this.hasMissingRequiredComment()) {
                return
            }
            let formMany = this.form.map(form => {
                return {
                    invoiceId: form.item.id,
                    status: form.status,
                    worker: form.worker,
                    comment: form.comment
                }
            })
            return this.workerAbsenceSelection.validate(this.form.map(form => form.worker)).then(canProceed => {
                if (canProceed) {
                    return Invoice.passMany(formMany).$promise.then(() => {
                        $uibModalInstance.close()
                        $rootScope.$broadcast(InvoiceConst.eventUpdate)
                    })
                }
            })
        }
    })
